<template>
  <div>
    <DialogForMassOperators
      :dialog.sync="dialogDelete"
      :loading.sync="loading"
      :head-text="$t('meter-units.delete-title-record')"
      :content-text="$t('meter-units.delete-dialog-record')"
      :confirm-button="{
        text: $t('tariffs.delete'),
        icon: 'mdi-trash-can-outline'
      }"
      :selected.sync="selected"
      v-on:update:selected="updateSelected"
      dispatch="projectMeteringStore/meterUnitRecordStore/deleteList"
      :on-success="updateList"
      permissions-item-key="_project"
      :record_type="meter_unit_record"
    ></DialogForMassOperators>
    <v-toolbar dense flat>
      <v-toolbar-title>{{ $t("meter-units.records") }}</v-toolbar-title>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          v-for="item in menu"
          :key="item.title"
          :to="item.to"
          text
          color="primary"
          :disabled="item.disabled"
          v-on:click="item.onClick()"
          ><v-icon left>{{ item.icon }}</v-icon> {{ item.title }}</v-btn
        >
      </v-toolbar-items>
    </v-toolbar>
    <v-row class="py-0 px-4">
      <v-col cols="12" sm="6" class="py-0">
        <DateTimeInput
          :date="$route.query.time_from"
          @update="val => setDate('time_from', val)"
          :date-label="$t('meter-units.from-date')"
          :time-label="$t('meter-units.from-time')"
        ></DateTimeInput>
      </v-col>
      <v-col cols="12" sm="5" class="py-0">
        <DateTimeInput
          :date="$route.query.time_to"
          @update="val => setDate('time_to', val)"
          :date-label="$t('meter-units.to-date')"
          :time-label="$t('meter-units.to-time')"
        ></DateTimeInput>
      </v-col>
      <v-col cols="2" sm="1" class="reset">
        <v-btn block v-on:click="reset">
          <v-icon>
            mdi-filter-remove-outline
          </v-icon>
        </v-btn>
      </v-col>
      <v-switch
        v-model="rawRecord"
        :label="$t('analysis.raw-record')"
        color="primary"
        @change="updateList"
      ></v-switch>
    </v-row>
    <CommonTable
      list-getter="projectMeteringStore/meterUnitRecordStore/getList"
      create-item-dispatch="projectMeteringStore/meterUnitRecordStore/create"
      update-item-dispatch="projectMeteringStore/meterUnitRecordStore/update"
      delete-item-dispatch="projectMeteringStore/meterUnitRecordStore/delete"
      :headers="headers"
      :slots="slots"
      :actions="actions"
      resource="meter-units"
      :static-dispatch-params="{
        project_id: $route.params.project_id,
        meter_unit_id: $route.params.id
      }"
      :can-add="rawRecord"
      :can-edit="rawRecord"
      :can-delete="rawRecord"
      @updated="updateList"
      show-select
      v-on:update:selected="updateSelected"
      :selected.sync="selected"
      :toggleState="rawRecord && valueCheck"
    ></CommonTable>
    <ul class="v-pagination">
      <li>
        <v-btn
          :class="['v-pagination__navigation']"
          @click="updatePage(prevUrl)"
          :disabled="!prevUrl"
          small
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </li>
      <li>
        <v-btn
          :class="['v-pagination__navigation']"
          @click="updatePage(nextUrl)"
          :disabled="!nextUrl"
          small
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </li>
    </ul>
    <Paginator
      page-getter="projectMeteringStore/meterUnitRecordStore/getPage"
    ></Paginator>
  </div>
</template>

<script>
import Paginator from "../../../common/tables/Paginator";
import CommonTable from "../../../common/tables/CommonTable";
import DateTimeInput from "../../../common/inputs/DateTimeInput";
import { rules } from "../../../mixins/rules";
import { projectPermissions } from "../../../mixins/projects/projectPermissions";
import { permissions } from "../../../../components/mixins/permissions";
import DialogForMassOperators from "../../../../components/common/dialogs/DialogForMassOperators.vue";
import moment from "moment";
export default {
  name: "RecordsListMeterUnit",
  components: {
    CommonTable,
    Paginator,
    DateTimeInput,
    DialogForMassOperators
  },
  mixins: [rules, projectPermissions, permissions],
  data: function() {
    return {
      headers: [
        {
          text: this.$t("meter-units.time"),
          align: "left",
          value: "time"
        },
        {
          text: this.$t("meter-units.value"),
          value: "value"
        },
        {
          text: this.$t("meter-units.author"),
          value: "modified",
          sortable: false
        },
        {
          text: this.$t("meter-units.action"),
          value: "action",
          align: "right",
          sortable: false
        }
      ],
      actions: [],
      rawRecord: true,
      nextUrl: null,
      prevUrl: null,
      selected: [],
      dialogDeleteOne: false,
      dialogDelete: false,
      loading: false,
      valueCheck: false
    };
  },
  computed: {
    getParams() {
      return `
              ${this.$route.query.limit_items}
              ${this.$route.query.orders}
              ${this.$route.query.time_to}
              ${this.$route.query.time_from}
              ${this.project.id}
              `;
    },
    meter_unit_record() {
      if (this.rawRecord) {
        return "raw";
      } else {
        return "aligned";
      }
    },
    meterUnit: {
      get() {
        return this.$store.getters[
          "projectMeteringStore/meterUnitStore/getItem"
        ];
      }
    },
    slots() {
      let rules = this.rules;
      let project = this.$store.getters["projectStore/getItem"];
      return [
        {
          name: "time",
          type: "date",
          dateTimeZone: project.timezone,
          form: {
            type: "date-time",
            rules: [rules.requiredForDate],
            visible: this.rawRecord
          }
        },
        {
          name: "value",
          type: "number",
          form: {
            type: "text",
            rules: [rules.required],
            visible: this.rawRecord
          }
        },
        {
          name: "modified",
          type: "records-modified"
        }
      ];
    },
    menu() {
      let vm = this;
      return [
        {
          title: this.$t("tariffs.delete"),
          to: null,
          onClick: function() {
            vm.dialogDelete = true;
          },
          disabled: !this.selected.length,
          icon: "mdi-trash-can-outline"
        }
      ];
    },
    project() {
      return this.$store.getters["projectStore/getItem"];
    },
    readonly: {
      get() {
        return !this.hasCurrentProjectPermissions("meter_unit.update");
      }
    }
  },
  watch: {
    getParams: function() {
      this.updateList();
    },
    rawRecord() {
      this.selected = [];
    }
  },
  methods: {
    updateList() {
      let params = this.formingParams();
      this.$store.dispatch(
        "projectMeteringStore/meterUnitRecordStore/getList",
        {
          params,
          onSuccess: response => {
            this.loading = false;
            this.nextUrl = response.cursor.next;
            this.prevUrl = response.cursor.prev;
            this.valueCheck = true;
          }
        }
      );
      this.valueCheck = false;
    },
    updateSelected(val) {
      this.$set(this.$data, "selected", val);
    },
    async updatePage(url) {
      if (!url) return;

      this.loading = true;

      try {
        await this.$store.dispatch(
          "projectMeteringStore/meterUnitRecordStore/fetchData",
          {
            url
          }
        );

        const cursor = this.$store.getters[
          "projectMeteringStore/meterUnitRecordStore/getCursor"
        ];
        this.nextUrl = cursor.next;
        this.prevUrl = cursor.prev;
      } catch (error) {
        this.$store.dispatch("notificationStore/createNotification", {
          text: this.$t("transmissions.error-parsing-data"),
          type: "error",
          value: true
        });
      } finally {
        this.loading = false;
      }
    },

    formingParams() {
      let project = this.project;
      let rawRecord = this.rawRecord;
      function toUTC(date) {
        return (
          date &&
          moment
            .tz(moment(date).format("YYYY-MM-DDTHH:mm:ss"), project.timezone)
            .utc()
            .format()
        );
      }
      return {
        project_id: this.$route.params.project_id,
        limit: this.$route.query.limit_items,
        orders:
          this.$route.query.orders ?? "time:desc/value:desc/meter_unit_id:desc",
        filters: {
          meter_unit: this.$route.params.id,
          time: {
            from: toUTC(this.$route.query.time_from),
            to: toUTC(this.$route.query.time_to)
          }
        },
        rawRecord: rawRecord
      };
    },
    setDate(date, val) {
      let newRoute = {
        name: this.$route.name,
        query: { ...this.$route.query },
        params: { ...this.$route.params }
      };
      if (val) {
        newRoute.query[date] = val;
      } else {
        delete newRoute.query[date];
      }
      delete newRoute.query.page;

      if (this.$route.fullPath !== this.$router.resolve(newRoute).href) {
        this.$router.push(newRoute);
      }
    },
    reset() {
      let to = { ...this.$route };
      to.query = {};
      this.$router.push(to);
      this.search = "";
    }
  },
  mounted() {
    this.$store.dispatch("projectMeteringStore/meterUnitStore/get", {
      project_id: this.$route.params.project_id,
      id: this.$route.params.id
    });
    this.updateList();
    this.$store.dispatch("projectStore/get", {
      id: this.$route.params.project_id
    });
    this.$route.params.project_id &&
      this.$store.dispatch("projectStore/get", {
        id: this.$route.params.project_id
      });
  }
};
</script>

<style scoped></style>
